import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const MoreReviewsFunnelBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => (
  <TemplateBuilderFactory
    template="more_reviews_funnel"
    defaultQualifyingQuestionCount={1}
    {...maxFollowUpCounts}
  >
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}, then ask them how strongly they would
              recommend your products or services to their friends.
            </div>
          </TemplateBuilderInputTriggerSection>
          <TemplateSubsectionLink />
          <TemplateBuilderReengagementSection>
            <div>
              Using the data collected from {props.channelName}, send them a{' '}
              {props.unicornEmailSelect} Email and {props.unicornSMSSelect} SMS
              text message sequence offering a reward for fans who leave a
              5-star review.
              <br />
              Send a note of apology to the upset customers with an offer to try
              to help them out.
            </div>
          </TemplateBuilderReengagementSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
